<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { campaignsExpanded } from './stores/nav';

    const title = 'Crowdsourcing';

    export let animate = true;

    let fgLimit = 0;
    let caretLimit = 0;
    let bgLimit = title.length;

    const dispatch = createEventDispatcher();

    if (animate) {
        const fgInterval = setInterval(() => {
            fgLimit += 1;
            if (fgLimit === title.length) {
                clearInterval(fgInterval);

                const caretInterval = setInterval(() => {
                    caretLimit += 1;
                    if (caretLimit === 5) {
                        clearInterval(caretInterval);
                    }
                }, 350);
                setTimeout(() => {
                    const bgInterval = setInterval(() => {
                        bgLimit -= 1;
                        if (bgLimit < 0) {
                            clearInterval(bgInterval);
                            dispatch('animationend');
                        }
                    }, 40);
                }, 2300);
            }
        }, 40);
    }
</script>

<a
    href="https://crowdsourcing.wien/"
    class="inline-flex items-center space-x-1 flex-shrink-0 no-underline whitespace-nowrap"
>
    <span class="text-xl transition-colors duration-300 inline-flex">
        {#each title as char, idx}
            <span
                class="{idx < fgLimit || !animate ? 'opacity-100' : 'opacity-0'} {!animate ||
                (idx > bgLimit && !$campaignsExpanded)
                    ? 'bg-black text-white'
                    : ''}">{char}</span
            >
        {/each}
    </span>
    <span class="text-base" class:opacity-0={animate && caretLimit % 2 === 0}>_</span>
</a>
